import ClearingAPI from '@shared/api';

export const {
    positions: { getBrokerLevel: getBrokerLevelPositions, getAllBrokerLevelSecurities },
    securities: { getLogo },
} = ClearingAPI.settings;
